module.exports = __webpack_public_path__ + "assets/img/Striver-Careers-Landing-Page-w540.10fd644d.webp";